import axios from 'axios';

import authConfig from '@/../auth_config.json';

export default {
    login({commit}, payload) {

        return new Promise((resolve, reject) => {

            const payloadBody = {
                grant_type: 'password',
                scope: 'read',
                username: payload.username,
                password: payload.password
            }
            axios.request({
                url: 'oauth/token',
                baseURL: authConfig.oauthDomain,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    "Accept-Language": "vi-VN",
                    "Authorization": `Basic ${btoa(`${authConfig.clientId}:${authConfig.clientSecret}`)}`
                },
                method: 'post',
                data: new URLSearchParams(payloadBody).toString()
            }).then(response => {

                localStorage.setItem("access_token", response.data.access_token);

                resolve(response);
            }).catch((error) => {
                reject(error)
            });
        })
    }
}
